































































import { Component, Prop, Vue } from 'vue-property-decorator'
import './LoginScreen.less'
import LoginForm from '@/components/LoginForm/LoginForm.vue'
import { getTrans } from '@/services/transService.ts'
import ForgetPasswordForm from '@/components/ForgetPasswordForm/ForgetPasswordForm.vue'
import ResetPasswordForm from '@/components/ResetPasswordForm/ResetPasswordForm.vue'

@Component({
    components: { LoginForm, ForgetPasswordForm, ResetPasswordForm },
})
export default class LoginScreen extends Vue {
    @Prop() private component!: string
    @Prop() private email!: string
    @Prop() private token!: string
    @Prop() private resetroute!: string

    trans(key) {
        return getTrans(key)
    }
}
